import { QueueListIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Status } from "../../common/components/status";
import { classNames } from "../../common/utils/classnames";
import { ReprocessDataPlanFragment } from "../../graphql/generated";

const ReprocessDataPlanPic: React.FC<{
  plan?: ReprocessDataPlanFragment;
  large?: boolean;
}> = ({ plan, large }) => {
  const status = React.useMemo(() => {
    return Status.for(plan);
  }, [plan]);

  return (
    <QueueListIcon
      className={classNames(
        status.color.picClasses(),
        large ? "h-20 w-20" : "h-10 w-10",
        "rounded-full border-2"
      )}
    />
  );
};

export default ReprocessDataPlanPic;
